import { WebRoutes } from "consts/enpoints/web";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingApplication } from "../../hooks";
import { useRiskAndCompliance } from "./useRiskAndCompliance";

const RiskAndCompliance = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const riskAndCompliance = useRiskAndCompliance();

    return (
        <Step
            title='Risk & Compliance'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.RiskAndCompliance.Form
                {...riskAndCompliance}
            />
        </Step>
    );
};

export default withApplication(RiskAndCompliance);
